<template>
    <LeftAsideSubLayout :title="selectedTag ? 'List Price Books / ' + selectedTag.name : 'List Price Books'">
        <template #aside>
            <span class="h-full overflow-auto py-4">
                <span class="ml-6 block w-full type-secondary font-medium pb-4 bg-gray-tier-3">
                    {{ $t("Browse by category") }}
                </span>
                <SideNav
                    class="w-full"
                    :sections="tagArray"
                    :click-to-scroll="false"
                    :all="true"
                    v-model="selectedTag"
                    @update:modelValue="setTagSelected"
                />
            </span>
        </template>
        <template #default>
            <div class="p-10">
                <div v-if="!selectedTag" class="shrink overflow-x-auto">
                    <AlphabetFilter
                        v-model="letterSelected"
                        :available-letters="availableLetters"
                        class="pb-8"
                    />
                </div>
                <div v-else class="p-4 mb-4 border border-gray-tier-7 rounded-md bg-gray-tier-5">
                    {{ $t("Category") }}:
                    <span class="font-bold">{{ selectedTag?.name }}</span>
                    <button
                        class="type-secondary hover:type-primary ml-4 underline underline-offset-4"
                        @click="selectedTag = null"
                    >
                        {{ $t("clear") }}
                    </button>
                </div>
                <ul class="w-full block">
                    <li v-for="manufacturer in filteredManufacturers">
                        <Divider />
                        <PriceBookCard :manufacturer="manufacturer" />
                    </li>
                </ul>
            </div>
        </template>
    </LeftAsideSubLayout>
</template>

<script setup>
import {AppSectionHeader, AlphabetFilter, Divider, PriceBookCard, SideNav, SideNavAlt} from "@/Components";
import { computed, ref } from "vue";
import {LeftAsideSubLayout} from "@/Layouts";

const props = defineProps([
    "manufacturers",
    "crumbs",
    "tags",
    "availableLetters",
]);

const selectedTag = ref(null);
const tagArray = ref(props.tags['vendor-category']);

const setTagSelected = (tag) => {
    letterSelected.value = "All";
    selectedTag.value = tagArray.value.filter((t) => t.name === tag)[0];
};

const letterSelected = ref("All");
const dropdownSeen = ref(false);

let filteredManufacturers = computed(() => {
    if (letterSelected.value !== "All") {
        const selectedLetter = letterSelected.value.toLowerCase();
        return props.manufacturers?.data?.reduce((acc, manufacturer) => {
            return manufacturer.name?.toLowerCase().startsWith(selectedLetter)
                ? [...acc, manufacturer]
                : acc;
        }, []);
    }
    if (selectedTag.value) {
        return props.manufacturers?.data?.reduce((acc, manufacturer) => {
            return manufacturer.tag_ids.includes(selectedTag.value.id)
                ? [...acc, manufacturer]
                : acc;
        }, []);
    }
    return props.manufacturers?.data;
});
</script>
